(function () {
  angular.module("akitabox.ui.dialogs.request.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.request",
    "akitabox.core.toast",
  ]);
})();
